angular.module 'zc.commonApi'

.factory "SegmentMatcher", ->
  service =

    getCombinedDeviceCondition: (device) ->
      switch device
        when 'pc' then {$in:['pc', 'tablet']}
        when 'sp', 'iphone' then 'sp'
        else {$exists: true}

    isDateString: (str) ->
      !(_.isNaN(Date.parse(str)) || /^\d\.?\d*$/.test(str))

    recursivelyReplaceZcVariables: (query) ->
      for k,v of query
        if _.isObject(v)
          found = false
          keys = Object.keys(v)
          if keys.length == 1
            key = keys[0]
            switch key
              when '$zcDaysFromNow'
                query[k] = moment().add(v[key], "days").toDate()
                found = true
              when '$zcSecondsFromNow'
                query[k] = moment().add(v[key], 'seconds').toDate();
                found = true
          if !found
            service.recursivelyReplaceZcVariables(v)
        else if service.isDateString(v)
          query[k] = new Date(v)

    createSegmentQuery: (query) ->
      segmentQuery = {}
      for k,v of query
        if _.startsWith(k, 'Session#')
          segmentQuery[k.slice('Session#'.length)] = v
      segmentQuery

    createHistoryQuery: (query) ->
      segmentQuery = {}
      for k,v of query
        if _.startsWith(k, 'History#')
          segmentQuery[k.slice('History#'.length)] = v
      segmentQuery

    createVisitorQuery: (query) ->
      visitorQuery = {}
      for k,v of query
        if _.startsWith(k, 'Visitor#')
          visitorQuery[k.slice('Visitor#'.length)] = v
      visitorQuery

    matchSessions: (query, sessions) ->
      query = _.merge {}, query
      service.recursivelyReplaceZcVariables(query)

      # use sift to match mongo query into arrays
      sift(query, sessions)

  service



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/misc/segment_matcher.service.coffee